'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import styles from 'components/error-boundary/error-boundary.module.scss';
import Button from 'components/controls/buttons/button';

export default function Error({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const [eventId, setEventId] = useState<string | null>(null);

	useEffect(() => {
		setEventId(Sentry.captureException(error));
	}, [error]);

	const handleReportFeedback = () => {
		Sentry.showReportDialog({ eventId: eventId ?? undefined });
	};

	return (
		<div className={styles.errorBoundary}>
			<h3>
				Something went wrong.
				<br />
				<span className={styles.subHeading}>
					We&apos;re sorry, but this service is temporarily unavailable. Please
					check back soon.
				</span>
			</h3>
			{eventId && <p>Our team has been notified of this occurrence.</p>}
			<Button appearance="secondary" onClick={() => reset()}>
				Try again
			</Button>
			<a
				role="button"
				className={styles.feedbackButton}
				onClick={handleReportFeedback}
			>
				Report feedback
			</a>
		</div>
	);
}
